export default "__VITE_ASSET__5jYu6OVi__"